import {ref, Ref} from "vue"

const isNewUser: Ref<boolean> = ref(false)

export default isNewUser